import { Box } from '@mui/material';
// import { LoomCard } from 'pages/LoomPage';
import React from 'react';
import { ACTIONS, EVENTS } from 'react-joyride';
import { CustomStep } from './Tutorial';

export const coordinationSteps = (): CustomStep[] => {
  const steps: CustomStep[] = [
    {
      content: (
        <Box sx={{ textAlign: 'left' }}>
          <b>Coordination details</b>
          <br></br>
          {/* <b>1. </b> */}
          {`Coordination items have a messaging system that allow you to collaborate with project stakeholders that do not have a Centerpiece account. You start by adding in a subject line, the recipient(s) and a due date (when you want these recipients to respond to you). `}
          <br></br>
          {/* <b>2. </b>We provide three configured message types: Approvals,
          Readiness, and General Messaging. These message types create different
          response options for the recipients.<br></br> */}
        </Box>
      ),
      styles: {
        tooltip: {
          maxWidth: '100%',
        },
        tooltipContainer: {
          maxWidth: '100%',
        },
      },
      target: '#tab-drawer-tab-1',
      disableBeacon: true,
      // disableScrolling: true,
      // disableScrollParentFix: true,
      // target: '.MuiAutocomplete-root',
      placement: 'left',
      offset: 100,
      [ACTIONS.NEXT]: {
        [EVENTS.TARGET_NOT_FOUND]: 'openCoordinationDrawer',
      },
      [ACTIONS.PREV]: {
        [EVENTS.STEP_AFTER]: 'closeCoordinationDrawer',
      },
    },
    {
      content: 'Add a "call to action" in your message',
      target: '#textfieldarray-speeddial',
      placement: 'auto',
      disableBeacon: true,
      [ACTIONS.NEXT]: {
        [EVENTS.STEP_AFTER]: 'closeCoordinationDrawer',
      },
      [ACTIONS.PREV]: {
        [EVENTS.TARGET_NOT_FOUND]: 'openCoordinationDrawer',
      },
    },
    // {
    //   content: (
    //     <Box sx={{ textAlign: 'left' }}>
    //       <b>Coordination details</b>
    //       <br></br>
    //       <b>3. </b>
    //       {`Use approval messages when you are seeking the recipients to approve a file and/or information in the email body. The recipients will be able to respond: Approved, Approved with Markups, Rejected, or Call Me. Use cases include approving: a) shop drawings, b) design layouts, c) quote/bid markups, d) contracts and e) submittals.`}
    //       <br></br>
    //       <LoomCard
    //         loom="https://www.loom.com/share/5bedb450a39b43d1aad44ec4168b438f"
    //         search=""
    //       />
    //     </Box>
    //   ),
    //   floaterProps: {
    //     styles: {
    //       floater: {
    //         width: '650px',
    //         maxWidth: '95%',
    //         marginRight: 'auto',
    //         marginLeft: 'auto',
    //       },
    //     },
    //   },
    //   styles: {
    //     tooltip: {
    //       width: '100%',
    //     },
    //   },
    //   target: '#textfieldarray-speeddial',
    //   disableBeacon: true,
    //   placement: 'left',
    //   [ACTIONS.NEXT]: {
    //     [EVENTS.TARGET_NOT_FOUND]: 'openCoordinationDrawer',
    //   },
    //   [ACTIONS.PREV]: {
    //     [EVENTS.STEP_AFTER]: 'closeCoordinationDrawer',
    //   },
    // },
    // {
    //   content: (
    //     <Box sx={{ textAlign: 'left' }}>
    //       <b>Coordination details</b>
    //       <br></br>
    //       <b>4. </b>Use readiness messages when you are trying to confirm if a
    //       jobsite is ready for your delivery and installation teams. The
    //       recipients will be able to respond: Confirmed, Not Ready, or Call Me.
    //       <br></br>
    //       <LoomCard
    //         loom="https://www.loom.com/share/7dc63a4b0f0340a1a408e82ae7f29b57"
    //         search=""
    //       />
    //     </Box>
    //   ),
    //   floaterProps: {
    //     styles: {
    //       floater: {
    //         width: '650px',
    //         maxWidth: '95%',
    //         marginRight: 'auto',
    //         marginLeft: 'auto',
    //       },
    //     },
    //   },
    //   styles: {
    //     tooltip: {
    //       width: '100%',
    //     },
    //   },
    //   target: '#type-field',
    //   disableBeacon: true,
    //   placement: 'left',
    //   [ACTIONS.NEXT]: {
    //     [EVENTS.TARGET_NOT_FOUND]: 'openCoordinationDrawer',
    //   },
    //   [ACTIONS.PREV]: {
    //     [EVENTS.STEP_AFTER]: 'closeCoordinationDrawer',
    //   },
    // },
    // {
    //   content: (
    //     <Box sx={{ textAlign: 'left' }}>
    //       <b>Coordination details</b>
    //       <br></br>
    //       <b>5. </b>
    //       {`Use default messages when you are requesting or sharing information and/or files. The recipients will not have pre-configured response options. They will be able to create a text response with file attachments. Use cases include: a) contract sharing, b) requesting pricing from vendors/reps, c) requesting shop drawings, d) requesting rough-in drawings, and e) sharing close-out documentation.`}
    //       <br></br>
    //       <LoomCard
    //         loom="https://www.loom.com/share/c3509f66ff0d45188e9cb816b1b67b45"
    //         search=""
    //       />
    //     </Box>
    //   ),
    //   floaterProps: {
    //     styles: {
    //       floater: {
    //         width: '650px',
    //         maxWidth: '95%',
    //         marginRight: 'auto',
    //         marginLeft: 'auto',
    //       },
    //     },
    //   },
    //   styles: {
    //     tooltip: {
    //       width: '100%',
    //     },
    //   },
    //   target: '#type-field',
    //   disableBeacon: true,
    //   placement: 'left',
    //   [ACTIONS.NEXT]: {
    //     [EVENTS.TARGET_NOT_FOUND]: 'openCoordinationDrawer',
    //   },
    //   [ACTIONS.PREV]: {
    //     [EVENTS.STEP_AFTER]: 'closeCoordinationDrawer',
    //   },
    // },
    // {
    //   content: (
    //     <Box sx={{ textAlign: 'left' }}>
    //       <b>Action Items</b>
    //       <br></br>
    //       <b>1. </b>Once you have selected a response type, you can add action
    //       item(s) to your message.<br></br>
    //       <b>2. </b>Here’s a basic example. If you wanted to get an approval on
    //       one shop drawing, you would add one action item. You then add a title,
    //       the details and the drawing attachment. If you wanted to approve
    //       multiple drawings, you could add an action item for each drawing. This
    //       allows you to request multiple approvals in the same email message.{' '}
    //       <br></br>
    //     </Box>
    //   ),
    //   target: '#action-item-field',
    //   floaterProps: {
    //     styles: {
    //       floater: {
    //         width: '650px',
    //         maxWidth: '95%',
    //         marginRight: 'auto',
    //         marginLeft: 'auto',
    //       },
    //     },
    //   },
    //   styles: {
    //     tooltip: {
    //       width: '100%',
    //     },
    //   },
    //   disableBeacon: true,
    //   placement: 'left',
    //   [ACTIONS.NEXT]: {
    //     [EVENTS.STEP_AFTER]: 'closeCoordinationDrawer',
    //   },
    //   [ACTIONS.PREV]: {
    //     [EVENTS.TARGET_NOT_FOUND]: 'openCoordinationDrawer',
    //   },
    // },
  ];
  return steps;
};
